var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import { Input } from "@irati/ui/src/FormItem";
import padding from "@irati/ui/src/global/padding";
import { poNumberSchema } from "@irati/wallet/helpers/validation";
var StyledRow = styled(Row)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: ", ";\n  margin-bottom: ", ";\n"], ["\n  margin-top: ", ";\n  margin-bottom: ", ";\n"])), padding.small, padding.small);
var PO_NUMBER = "PO Number";
var PONumber = /** @class */ (function (_super) {
    __extends(PONumber, _super);
    function PONumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PONumber.prototype.render = function () {
        var _a = this.props, value = _a.value, onChange = _a.onChange;
        return (React.createElement(StyledRow, null,
            React.createElement(Input, { label: "wallet.tenant.topUp.poNumber", name: PO_NUMBER, value: value, onChange: onChange, validation: poNumberSchema })));
    };
    return PONumber;
}(Component));
export default PONumber;
var templateObject_1;
